import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import invitationsApi from '@/features/dashboard/invitations/api/invitationsApi.ts';
import { invitationsApiQueryKeys } from '@/features/dashboard/invitations/api/invitationsApi.queryKeys.ts';

const useCancelInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => invitationsApi.cancel(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: invitationsApiQueryKeys.all(),
      });
      toast.success('Zaproszenie zostało anulowane');
    },
    onError: (error) => {
      toast.error('Wystąpił błąd', {
        description: error.message,
      });
    },
  });
};

export default useCancelInvitation;
